export default __webpack_public_path__ + "static/media/logo-gov_br.dd6523cb.svg";